/// <amd-module name="SearchUI/SearchResultItem" />
export * from "SearchUI/Components/SearchResultItemComponent/index";